/**
 * Query keys that hold canvases. Kept dependency-free so modules that only
 * need the keys (favorites, realtime) don't pull in the canvas API.
 */

/**
 * Plain `Canvas[]` list caches, by prefix. `["canvases"]` covers recent, all
 * and favorites; the workspace-scoped lists (`["workspaces", id, "canvases"]`)
 * are addressed per workspace instead, so a mutation touches one workspace.
 */
export const CANVAS_LIST_QUERY_KEYS: string[][] = [
  ["canvases"],
  ["canvas", "sharedWithMe"],
];

/**
 * Every cache that can embed a canvas, detail entries included. Only the
 * favorite toggle needs this reach: a star rewrites `tags` on every copy of
 * the row, whichever endpoint fetched it.
 */
export const CANVAS_FAVORITE_QUERY_KEYS: string[][] = [
  ["canvases"],
  ["canvas"],
  ["workspaces"],
];
